/* eslint-disable react/no-array-index-key */
import { Spacing4, Spacing40, Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductListItemModel } from 'autogen/swagger/all';
import { PictogramSplash, RoundSplash } from 'components/shared/Splash';
import styled from 'styled-components';

export const SplashOverlayContainer = styled.div`
    position: absolute;
    top: ${Spacing40};
    left: ${Spacing4};
    width: calc(100% - ${Spacing8});
    height: calc(100% - ${Spacing40} - ${Spacing4});
    display: flex;
    flex-direction: column;
    gap: ${Spacing8};
    opacity: 1;
    transition: opacity ease 0.2s;
    justify-content: end;
    z-index: 1;
`;

const PictogramContainer = styled.div`
    display: grid;
    align-content: end;
    gap: ${Spacing4};
`;

export default function SplashOverlay(splashes: ProductListItemModel['splashes']) {
    const { extra } = splashes;
    const hazardSplashes = extra.filter((splash) => splash.type === 'Hazard');
    const medicalSplash = extra.find((splash) => splash.type === 'OtcMinAge');

    return (
        <SplashOverlayContainer>
            {hazardSplashes.length > 0 && (
                <PictogramContainer>
                    {hazardSplashes.map((splash, index) => (
                        <PictogramSplash {...splash} key={index} />
                    ))}
                </PictogramContainer>
            )}

            {medicalSplash && <RoundSplash {...medicalSplash} />}
        </SplashOverlayContainer>
    );
}
